import { Pagination } from '$core/models/pagination';
import { SearchResults } from '$core/shell/main-search/main-search.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor() {}
}

@Injectable({
  providedIn: 'root',
})
export class BlogSearchService {
  public enabled$ = new Subject<boolean>();
  private _enabled = false;
  public get enabled() {
    return this._enabled;
  }
  public set enabled(value) {
    this._enabled = value;
    this.enabled$.next(value);
  }
  public items = null;
  public isLoading = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (e) => {
      const search = e['search'];
      if (search) {
        this.items = null;
        this.isLoading = true;
        this.router.navigate(['/'], {
          queryParams: { search },
          queryParamsHandling: 'merge',
        });
        this.enabled = true;
        this.items = await this.searchItems(search);
        this.isLoading = false;
      } else {
        this.items = null;
        this.isLoading = false;
        this.enabled = false;
      }
    });
  }

  public async triggerSearch(search: string) {
    if (!search) {
      this.stopSearch();
      return;
    }
    this.router.navigate(['/'], {
      queryParams: { search },
      queryParamsHandling: 'merge',
    });
  }

  public searchItems(search: string) {
    return this.http
      .get<any>('/v1/blog/search', { params: { search } })
      .pipe(
        map((el) => {
          el.data.map((element) => new SearchResults(element));
          return el;
        })
      )
      .toPromise();
  }

  public nextPage(url) {
    return this.http.request<Pagination<SearchResults>>('get', url).pipe(
      map((el) => {
        el.data.map((element) => new SearchResults(element));
        return el;
      })
    );
  }

  public stopSearch() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { search: null },
      queryParamsHandling: 'merge',
    });
  }
}
